const productData = [
  {
    id: 1,
    name: "Ocean Buddies Opal the Octopus",
    category: "Toys",
    price: "19.9",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.webp",
    images: ["/img/101.webp"],
    size: ["Small", "Medium", "Large"],
    colors: ["Purple", "Coral Pink", "Seafoam Green"],
    material: "100% Recycled Polyester Plush, Squeaker Inside",
    description: [
      "Opal the Octopus is a delightfully squishy plush toy featuring eight soft tentacles that are perfect for gentle chewing and interactive play sessions.",
      "Each tentacle is designed with varying textures to engage your pet's natural curiosity and provide sensory stimulation during playtime.",
      "The built-in squeaker adds an exciting element that keeps dogs entertained for hours, encouraging active play and exercise.",
      "Crafted from eco-friendly recycled materials, this octopus toy supports sustainable pet product manufacturing.",
      "Machine washable for easy cleaning, ensuring long-lasting hygiene and freshness after countless muddy adventures.",
      "Designed with safety in mind, featuring reinforced stitching that withstands regular play without compromising the plush exterior.",
    ],
    Features: [
      "Eight textured tentacles for chewing and interactive play",
      "Integrated squeaker for auditory stimulation",
      "Made from 100% recycled polyester materials",
      "Reinforced seams for durability against rough play",
      "Multiple color options to match your pet's personality",
      "Available in three sizes for dogs of all breeds",
      "Machine washable for easy care",
      "Suitable for indoor and outdoor play",
    ],
  },
  {
    id: 2,
    name: "Ocean Buddies Big Blue & Baby Blue",
    category: "Toys",
    price: "22.9",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "Sky Blue"],
    material: "Premium Plush Fabric, Crinkle Material, Squeaker",
    description: [
      "Big Blue and Baby Blue are a dynamic duo of ocean-themed plush toys that bring double the fun to playtime.",
      "The crinkle material inside creates a satisfying crinkly sound that captures your pet's attention and stimulates their natural hunting instincts.",
      "Big Blue serves as the main plush companion while Baby Blue can be tucked inside for a fetch-and-retrieve adventure.",
      "Both toys feature soft, huggable bodies that are perfect for cuddling during quiet time or naptime.",
      "The contrasting blue colors make these toys easy to locate during outdoor play sessions at the park or backyard.",
      "Each toy includes a hidden squeaker that rewards your pet with delightful sounds upon every bite and shake.",
    ],
    Features: [
      "Set of two complementary ocean-themed toys",
      "Crinkle texture for auditory stimulation",
      "Hidden squeaker in each toy",
      "Contrasting sizes for variety in play",
      "Soft plush exterior for cuddling",
      "Bright colors for easy visibility",
      "Great for solo or interactive play between pets",
      "Lightweight design for easy carrying",
    ],
  },
  {
    id: 3,
    name: "Ocean Buddies Lemmy the Lobster",
    category: "Toys",
    price: "19.5",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.webp",
    images: ["/img/103.webp"],
    size: ["Medium", "Large"],
    colors: ["Red", "Ocean Blue", "Coral"],
    material: "Durable Canvas, Plush Accents, Squeaker",
    description: [
      "Lemmy the Lobster brings underwater adventure to your pet's toy collection with his charming claw-waving design.",
      "The lobster's oversized claws are perfect for dogs who love to grab, shake, and carry their toys during play sessions.",
      "Constructed with a durable canvas body that can withstand enthusiastic chewing while remaining gentle on your pet's teeth and gums.",
      "The crinkle-filled tail adds an exciting element that dogs find irresistible, triggering their natural prey drive.",
      "Lemmy's whimsical appearance makes him a favorite among pet parents who appreciate fun, conversation-starting toys.",
      "Webbed feet details add realistic touches while providing additional textured surfaces for your pet to explore with their paws and mouth.",
    ],
    Features: [
      "Oversized claws for grabbing and shaking",
      "Crinkle-filled tail for auditory excitement",
      "Durable canvas body construction",
      "Realistic lobster design with playful details",
      "Textured webbed feet for sensory engagement",
      "Built-in squeaker for reward-based play",
      "Multiple color options available",
      "Suitable for medium to large dogs",
    ],
  },
  {
    id: 4,
    name: "Ocean Buddies Great White Gabe",
    category: "Toys",
    price: "16.5",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp", "/img/105.webp"],
    size: ["Small", "Medium", "Large", "Extra Large"],
    colors: ["Grey", "White", "Navy"],
    material: "Tuff-Rated Canvas, Plush, Squeaker",
    description: [
      "Great White Gabe is a tough and loveable shark toy from the Ocean Buddies collection, featuring the iconic fin that stands tall during play.",
      "Gabe's durable canvas body is designed to endure the rigors of daily play, making him an ideal choice for power chewers.",
      "The signature shark fin adds an exciting tactile element that dogs love to grab and carry around the house.",
      "An embedded squeaker provides satisfying sounds that encourage continued play and exercise, promoting healthy activity levels.",
      "Gabe's realistic shark appearance appeals to pet owners looking for unique toys that break away from conventional designs.",
      "The toy floats in water, making bath time and pool play even more entertaining for water-loving dogs.",
    ],
    Features: [
      "Iconic shark fin design for grabbing and carrying",
      "Tuff-rated canvas construction for durability",
      "Floats in water for aquatic play",
      "Embedded squeaker for auditory stimulation",
      "Realistic shark appearance",
      "Available in four sizes from small to extra large",
      "Suitable for indoor, outdoor, and water play",
      "Reinforced stitching for rough chewers",
    ],
  },
  {
    id: 5,
    name: "Ocean Buddies Bonk the Hammerhead",
    category: "Toys",
    price: "16.5",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp"],
    size: ["Medium", "Large"],
    colors: ["Blue", "Teal", "Sand"],
    material: "Plush, Canvas, Squeaker",
    description: [
      "Bonk the Hammerhead brings prehistoric charm to playtime with his distinctive hammer-shaped head that pets find irresistible.",
      "The unique hammerhead shape creates an asymmetrical design that rolls and bounces unpredictably, keeping dogs engaged and excited.",
      "This toy combines soft plush comfort with durable canvas accents, striking the perfect balance between cuddly and tough.",
      "Bonk is equipped with multiple squeakers positioned throughout the body, delivering a symphony of sounds with every play interaction.",
      "The elongated body is perfect for dogs who love to shake and thrash their toys, mimicking natural hunting behaviors.",
      "Vibrant color patterns make Bonk easy to spot during outdoor adventures at the beach, park, or backyard.",
    ],
    Features: [
      "Unique hammerhead shape for unpredictable movement",
      "Multiple squeaker locations for varied sounds",
      "Elongated body ideal for shaking play",
      "Combines plush comfort with canvas durability",
      "Engages natural hunting and chasing instincts",
      "Bright, eye-catching colors",
      "Great for fetch and tug games",
      "Promotes active play and exercise",
    ],
  },
  {
    id: 6,
    name: "Ocean Buddies Reef Retreat",
    category: "Beds",
    price: "18.9",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.webp",
    images: ["/img/106.webp"],
    size: ["Small", "Medium", "Large", "Extra Large"],
    colors: ["Purple", "Seafoam", "Sand"],
    material: "Sherpa Fabric, Memory Foam Fill, Waterproof Liner",
    description: [
      "The Reef Retreat bed transforms your pet's resting space into an underwater paradise with its coral reef-inspired design.",
      "Plush sherpa fabric provides cloud-like softness that pets sink into, offering supreme comfort for hours of restful sleep.",
      "The bed features a removable, machine-washable cover that makes cleaning effortless while maintaining freshness.",
      "Built with supportive memory foam that conforms to your pet's body shape, alleviating pressure on joints and bones.",
      "The waterproof inner liner protects the foam fill from accidents and spills, extending the bed's lifespan significantly.",
      "Elevated bolster sides create a sense of security and provide the perfect spot for pets to rest their heads comfortably.",
      "Non-slip bottom fabric ensures the bed stays in place on any floor surface, preventing sliding and bunching.",
    ],
    Features: [
      "Coral reef-inspired aesthetic design",
      "High-loft sherpa fabric for ultimate softness",
      "Memory foam base for joint support",
      "Waterproof inner liner for accident protection",
      "Removable, machine-washable cover",
      "Raised bolster sides for head support",
      "Non-slip bottom for stability",
      "Available in four sizes for all breed sizes",
    ],
  },
  {
    id: 7,
    name: "Ocean Buddies Seahorse",
    category: "Toys",
    price: "13.9",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.webp",
    images: ["/img/107.webp"],
    size: ["Small", "Medium"],
    colors: ["Orange", "Blue", "Pink"],
    material: "Plush Fabric, Crinkle Material, Squeaker",
    description: [
      "The Seahorse toy features a whimsical curled tail that dogs love to wrap their paws around during play sessions.",
      "Its gentle curves and soft body make this toy perfect for smaller breeds and puppies who prefer softer play experiences.",
      "The seahorse's delicate dorsal fin and ridged back provide textured surfaces for teething puppies to explore safely.",
      "An internal crinkle layer creates satisfying sounds that captivate your pet's attention and encourage active engagement.",
      "Vibrant gradient colors make this toy visually appealing while the plush texture provides comfort during cuddle time.",
      "The compact size makes it ideal for travel, ensuring your pet has a familiar comfort toy wherever adventures lead.",
    ],
    Features: [
      "Curled tail design for wrapping and carrying",
      "Crinkle material for sound stimulation",
      "Textured fins and back for teething relief",
      "Soft plush exterior for cuddling",
      "Lightweight and portable size",
      "Available in three vibrant color options",
      "Perfect for small dogs and puppies",
      "Suitable for supervised play sessions",
    ],
  },
  {
    id: 8,
    name: "Ocean Buddies Moorish Idol",
    category: "Toys",
    price: "13.9",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.webp",
    images: ["/img/108.webp"],
    size: ["Medium", "Large"],
    colors: ["Yellow", "Black", "White"],
    material: "Canvas, Plush, Squeaker",
    description: [
      "The Moorish Idol fish toy showcases the iconic yellow and black striped pattern that makes this tropical fish instantly recognizable.",
      "Its tall, elongated dorsal fin creates an excellent handle for tug-of-war games between pets and their human companions.",
      "The streamlined body shape makes this toy excellent for fetch, as it glides through the air with surprising aerodynamic efficiency.",
      "Bold black and yellow coloring provides high visibility during outdoor play, reducing the risk of losing the toy in grass or leaves.",
      "Multiple squeaker locations throughout the body ensure that every interaction produces delightful sounds that dogs adore.",
      "Canvas accents reinforce high-contact areas, extending the toy's lifespan even with regular rough play.",
    ],
    Features: [
      "Iconic Moorish Idol striped pattern",
      "Tall dorsal fin serves as a tug handle",
      "Streamlined body for excellent fetch performance",
      "High-visibility yellow and black colors",
      "Multiple squeaker locations",
      "Canvas reinforcement on high-impact areas",
      "Ideal for interactive play sessions",
      "Durable construction for extended use",
    ],
  },
  {
    id: 9,
    name: "Ocean Buddies Puffer Fish",
    category: "Toys",
    price: "17.5",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp"],
    size: ["Small", "Medium", "Large"],
    colors: ["Yellow", "Spotted", "Blue"],
    material: "Plush, Spiky Tassist Fibers, Squeaker",
    description: [
      "The Puffer Fish toy captures the charm of this round, spiky sea creature with its adorable puffed-up appearance.",
      "Textured Tassist fibers cover the body, providing unique sensory experiences for dogs who enjoy exploring different textures.",
      "The compact, round shape makes this toy perfect for toss and fetch games, bouncing unpredictably across various surfaces.",
      "An embedded squeaker rewards your pet's interaction, creating positive reinforcement that encourages continued play.",
      "The spiky texture satisfies your pet's natural scratching and gnawing instincts while being gentle on gums and teeth.",
      "Available in spotted, white, and blue variations, each featuring the characteristic rounded puffer fish silhouette.",
    ],
    Features: [
      "Round, puffed-up puffer fish design",
      "Tassist fiber texture for sensory stimulation",
      "Compact shape for toss and fetch play",
      "Built-in squeaker for reward sounds",
      "Textured surface for scratching relief",
      "Multiple color options including spotted designs",
      "Great for dogs who love textured toys",
      "Lightweight and easy to carry",
    ],
  },
  {
    id: 10,
    name: "Ocean Buddies Angler Fish",
    category: "Toys",
    price: "16.9",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.webp",
    images: ["/img/1010.webp"],
    size: ["Medium", "Large"],
    colors: ["Brown", "Bioluminescent Blue"],
    material: "Canvas, Plush, LED Light Element, Squeaker",
    description: [
      "The Angler Fish toy features a fascinating bioluminescent lure that glows in the dark, adding excitement to evening play sessions.",
      "The unique deep-sea predator design brings mysterious ocean depths into your home with its dark, mysterious appearance.",
      "A soft plush body contains multiple squeakers that create intriguing sounds, mimicking the surprises of deep-sea exploration.",
      "The illuminated lure cord dangles enticingly, providing an irresistible target for dogs who love to chase and catch moving objects.",
      "Dark canvas material on the lure adds durability to this unique appendage that will see plenty of attention during play.",
      "This toy is perfect for creating interactive bonding moments during evening playtime when other toys lose their appeal.",
    ],
    Features: [
      "Glowing bioluminescent lure for dark play",
      "Deep-sea angler fish design",
      "Multiple squeakers in the body",
      "Soft plush with canvas lure construction",
      "Dangling lure cord for chasing excitement",
      "Creates engaging evening play experiences",
      "Mysterious dark aesthetic",
      "Ideal for interactive owner-Petmorvanto",
    ],
  },
  {
    id: 11,
    name: "Ocean Buddies Collection",
    category: "Toys",
    price: "18.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp"],
    size: ["One Size Set"],
    colors: ["White"],
    material: "Various Plush Types, Mixed Textures",
    description: [
      "The Ocean Buddies Collection brings together an assortment of sea creature toys in one gift-worthy package.",
      "This curated set includes a variety of ocean animals, each with unique textures, sounds, and play experiences.",
      "Perfect for gifting, the collection comes in an attractive reusable container that keeps toys organized when not in use.",
      "Different toy shapes within the set appeal to various play styles, from gentle cuddlers to enthusiastic chewers.",
      "The variety ensures that pets stay engaged with fresh options during playtime, preventing boredom from repetitive play.",
      "Each toy in the collection is crafted with the same quality standards as individual Ocean Buddies products.",
      "An excellent choice for introducing puppies to different toy types or for multi-pet households.",
    ],
    Features: [
      "Curated set of multiple sea creature toys",
      "Variety of textures and sound types",
      "Attractive reusable packaging",
      "Suitable for various play preferences",
      "Keeps pets engaged with diverse options",
      "Perfect for gifting occasions",
      "Quality construction throughout",
      "Great for households with multiple pets",
    ],
  },
  {
    id: 12,
    name: "Party Animal Collection",
    category: "Toys",
    price: "63.9",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp"],
    size: ["Small", "Medium", "Large"],
    colors: ["Orange", "Rainbow", "Pastel"],
    material: "Festive Fabric, Confetti Material, Squeakers",
    description: [
      "The Party Animal Collection celebrates every celebration with toys that bring festive joy to everyday play.",
      "Each toy in the collection features celebratory colors and party-themed embellishments that delight both pets and their humans.",
      "Hidden confetti elements inside create crinkly surprises that reward your pet's exploration and play.",
      "The collection includes toys perfect for daily play while being special enough for birthday celebrations and festive occasions.",
      "Durable construction ensures these festive favorites last through countless party games and regular play sessions alike.",
      "The bright, cheerful colors bring positivity to any room and make these toys easy to locate during cleanup time.",
      "An ideal gift for pet birthdays or as party favors when celebrating milestones with your furry companion.",
    ],
    Features: [
      "Festive party-themed designs",
      "Hidden confetti elements for crinkly sounds",
      "Celebratory color combinations",
      "Durable construction for everyday play",
      "Perfect for birthday celebrations",
      "Bright colors for easy visibility",
      "Suitable as pet gifts or party favors",
      "Multiple size options available",
    ],
  },
  {
    id: 13,
    name: "Party Animal Balloon Buddy",
    category: "Toys",
    price: "13.9",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp"],
    size: ["Small", "Medium", "Large"],
    colors: ["Orange", "Blue", "Yellow", "Multi"],
    material: "Latex-inspired Fabric, Squeaker, Crinkle Fill",
    description: [
      "The Balloon Buddy toy captures the joy of birthday celebrations with its cheerful balloon animal-inspired design.",
      "Soft crinkle material fills the body, creating satisfying sounds that keep dogs engaged during solo play sessions.",
      "The elongated shape is perfect for dogs who love to grab, carry, and shake their toys with enthusiasm.",
      "Available in classic party colors including red, blue, and yellow, each balloon buddy brings its own festive personality.",
      "The lightweight design makes this toy perfect for outdoor fetch games at the park or beach adventures.",
      "Reinforced stitching ensures that even enthusiastic celebrations don't result in premature toy retirement.",
      "A hidden squeaker adds an element of surprise that dogs find irresistible during play and exploration.",
    ],
    Features: [
      "Balloon animal-inspired fun design",
      "Lightweight for easy fetching",
      "Crinkle-filled body for satisfying sounds",
      "Classic party color options",
      "Hidden squeaker for surprise sounds",
      "Elongated shape for carrying and shaking",
      "Reinforced construction for durability",
      "Great for indoor and outdoor play",
    ],
  },
  {
    id: 14,
    name: "Party Animal Fiesta Fetch Pinata",
    category: "Toys",
    price: "17.5",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp"],
    size: ["Medium", "Large"],
    colors: ["Pink", "Blue", "Green"],
    material: "Festive Fringe Fabric, Cardboard Core, Hidden Treat Pockets",
    description: [
      "The Fiesta Fetch Pinata brings the excitement of celebration directly to your pet's playtime with its colorful fringe design.",
      "Hidden treat pockets inside allow you to stuff small treats that reward your pet as they play and discover the hidden treasures.",
      "The fringe exterior satisfies your pet's scratching and chewing instincts while adding visual festivity to toy time.",
      "Perfect for stuffing games that provide mental stimulation and extend play sessions through reward-based discovery.",
      "The traditional pinata silhouette makes this toy a conversation piece that guests will admire during pet parties.",
      "Durable fabric construction ensures the pinata survives enthusiastic play while maintaining its festive appearance.",
      "An excellent enrichment tool that combines physical play with mental challenges for comprehensive entertainment.",
    ],
    Features: [
      "Colorful fringe pinata design",
      "Hidden treat pockets for reward play",
      "Scratch-friendly exterior fringe",
      "Provides mental enrichment through discovery",
      "Festive appearance for celebrations",
      "Durable fabric construction",
      "Combines physical and mental stimulation",
      "Great for interactive play sessions",
    ],
  },
  {
    id: 15,
    name: "Party Animal Barkday Wishes",
    category: "Toys",
    price: "10.9",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.webp",
    images: ["/img/1015.webp"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "Gift Box", "Party Hat"],
    material: "Festive Plush, Crinkle Material, Squeaker",
    description: [
      "Barkday Wishes is the perfect toy to celebrate your pet's special day with its charming birthday-themed design.",
      "The toy features multiple layers including crinkle material and squeakers that create engaging play experiences.",
      "Adorable birthday motifs like cake candles and party hats add whimsy that pet parents find absolutely adorable.",
      "This toy makes the perfect gift for your pet's birthday or Gotcha Day anniversary celebrations.",
      "The soft plush body provides comfort during quiet moments while the interactive elements encourage active play.",
      "Festive colors including pink, blue, and confetti patterns make this toy stand out in any toy collection.",
      "Built with the durability needed for everyday play while retaining the special feeling of a birthday gift.",
    ],
    Features: [
      "Birthday-themed celebratory design",
      "Multiple squeakers for varied sounds",
      "Crinkle material for tactile engagement",
      "Perfect for birthday gift-giving",
      "Soft plush for cuddling comfort",
      "Festive party colors and patterns",
      "Suitable for everyday play",
      "Commemorates special pet occasions",
    ],
  },
  {
    id: 16,
    name: "Party Animal Tug n' Party Banner",
    category: "Toys",
    price: "17.5",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp"],
    size: ["One Size"],
    colors: ["Pink", "Pastel", "Bold Colors"],
    material: "Fabric Banner, Rope Tugs, Squeaker",
    description: [
      "The Tug n' Party Banner combines festive decoration with interactive play, featuring a party banner attached to tug ropes.",
      "Double-ended rope tugs provide excellent grip points for intense tug-of-war sessions between pets and their humans.",
      "The attached banner adds visual excitement while creating unpredictable movement that dogs love to chase and catch.",
      "Perfect for incorporating into pet birthday parties as both decoration and entertainment for the guest of honor.",
      "High-quality rope fibers withstand aggressive tugging while being gentle on teeth and gums during play.",
      "The festive banner section features party-themed colors that brighten any space when displayed after playtime.",
      "An innovative hybrid design that maximizes play value from every angle of this multi-functional toy.",
    ],
    Features: [
      "Party banner with integrated tug ropes",
      "Double-ended for versatile play options",
      "Unpredictable banner movement for excitement",
      "Perfect for pet birthday celebrations",
      "Durable rope fibers for intense tugging",
      "Festive colors add party atmosphere",
      "Functions as decoration and toy",
      "Encourages bonding through interactive play",
    ],
  },
  {
    id: 17,
    name: "Fog City Pet x Feline Frenzy Mystic Mushrooms",
    category: "Toys",
    price: "10.5",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp"],
    size: ["One Size"],
    colors: ["Red", "Orange Cap", "Purple Cap"],
    material: "Crinkle Fabric, Catnip-Infused Filling, Feather Accents",
    description: [
      "Mystic Mushrooms is a cat toy collaboration between Fog City Pet and Feline Frenzy, featuring enchanting mushroom designs that cats find irresistible.",
      "Organic catnip filling inside drives cats wild with excitement, encouraging active play and exercise that benefits their health.",
      "Feathered tentacles beneath each mushroom cap flutter enticingly, triggering your cat's natural hunting and pouncing instincts.",
      "The crinkle material in stems and caps creates satisfying sounds that capture and maintain feline attention during play.",
      "Three color variations—red, orange, and purple caps—each offer the same irresistible play experience.",
      "The compact size is perfect for batting, chasing, and pouncing on floors or between furniture pieces.",
      "Filled with premium Canadian-grown catnip that remains potent for extended periods of play enjoyment.",
    ],
    Features: [
      "Catnip-infused filling for feline excitement",
      "Feather accents trigger hunting instincts",
      "Crinkle sounds for auditory stimulation",
      "Enchanting mushroom design",
      "Three cap color options",
      "Organic premium catnip",
      "Compact size for active play",
      "Collaboration between Fog City Pet and Feline Frenzy",
    ],
  },
  {
    id: 18,
    name: "Fog City Pet x Feline Frenzy Fur-mented Loaf Kicker Toy",
    category: "Toys",
    price: "11.9",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.webp",
    images: ["/img/1018.webp"],
    size: ["One Size"],
    colors: ["Brown", "Cinnamon", "Cream"],
    material: "Soft Plush, Crinkle Fill, Catnip",
    description: [
      "The Fur-mented Loaf Kicker captures the cozy essence of a freshly baked loaf with its adorable bread-inspired design.",
      "Long kickable appendages extend from the loaf body, allowing cats to practice their signature bunny-kick attacks.",
      "Catnip-infused filling makes this toy irresistible to cats of all ages, from playful kittens to sophisticated seniors.",
      "The soft plush exterior provides comforting textures that cats love to knead and rub against during relaxation.",
      "Crinkle material hidden inside adds unexpected sounds that enhance the play experience and maintain interest.",
      "The loaf shape fits perfectly in standard cat beds, providing comfort and entertainment during naptime.",
      "Sourdough, cinnamon, and cream color options each feature the same satisfying kickable design cats adore.",
    ],
    Features: [
      "Bread loaf-inspired cozy design",
      "Extended kickable sections for bunny kicks",
      "Catnip-infused for feline attraction",
      "Soft plush for comforting textures",
      "Hidden crinkle sounds",
      "Perfect size for cat beds",
      "Multiple color options",
      "Encourages natural kicking behavior",
    ],
  },
  {
    id: 19,
    name: "Fog City Pet x P.L.A.Y. Pine Pals",
    category: "Toys",
    price: "16.5",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp"],
    size: ["Small", "Medium"],
    colors: ["Green", "Brown", "Red Berries"],
    material: "Natural Fibers, Pine-scented Fill, Rope Elements",
    description: [
      "Pine Pals brings the fresh scent of the forest into your cat's playtime with thoughtfully designed woodland creature toys.",
      "Natural pine-scented filling creates an immersive forest experience that cats find calming and stimulating.",
      "Rope tail elements satisfy your cat's natural scratching instincts while providing excellent grip for carrying and tossing.",
      "The woodland creature designs—including squirrels, hedgehogs, and forest birds—bring outdoor adventure indoors.",
      "Eco-friendly materials align with P.L.A.Y.'s commitment to sustainable pet product manufacturing practices.",
      "The natural color palette blends beautifully with home decor while satisfying cats' preferences for earthy tones.",
      "Durable construction ensures these forest friends last through countless adventures in living rooms and windowsills alike.",
    ],
    Features: [
      "Pine-scented filling for forest ambiance",
      "Woodland creature designs",
      "Rope elements for scratching and carrying",
      "Natural, earthy color palette",
      "Eco-friendly sustainable materials",
      "Durable construction for extended play",
      "Brings outdoor adventure indoors",
      "Collaboration between Fog City Pet and P.L.A.Y.",
    ],
  },
  {
    id: 20,
    name: "Fog City Pet x P.L.A.Y. Fun-Guy",
    category: "Toys",
    price: "12.9",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp"],
    size: ["One Size"],
    colors: ["Brown", "Orange", "Purple"],
    material: "Soft Plush, Crinkle Stems, Catnip",
    description: [
      "The Fun-Guy toy transforms ordinary playtime into a whimsical fungal adventure with its charming mushroom design.",
      "A large spotted cap sits atop a crinkly stem, creating a toy that offers multiple play experiences in one.",
      "Catnip filling in both cap and stem ensures that every pounce, batting, and carrying session rewards your cat.",
      "The flexible stem bends and bounces back, creating unpredictable movement that triggers chase instincts.",
      "Three color variations—classic red with white spots, orange, and mystical purple—suit different aesthetic preferences.",
      "The compact, lightweight design makes this toy perfect for travel, ensuring your cat has entertainment everywhere.",
      "From coffee tables to cat trees, the Fun-Guy adds playful charm to any space while keeping cats active and engaged.",
    ],
    Features: [
      "Charming mushroom toy design",
      "Spotted cap options in three colors",
      "Crinkly stem for sound and flexibility",
      "Catnip-filled for feline attraction",
      "Bouncy, unpredictable movement",
      "Compact and lightweight for travel",
      "Versatile play on any surface",
      "Collaboration between Fog City Pet and P.L.A.Y.",
    ],
  },
];

export default productData;
